var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_758",
    "data-name": "Group 758",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12.876,
    height: 12.243,
    viewBox: "0 0 12.876 12.243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_436",
    "data-name": "Rectangle 436",
    width: 12.876,
    height: 12.243,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_757",
    "data-name": "Group 757",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1657",
    "data-name": "Path 1657",
    d: "M6.439,0a.518.518,0,0,1,.485.3q.821,1.666,1.646,3.33a.158.158,0,0,0,.135.1c.68.1,1.36.2,2.039.294.563.081,1.126.16,1.688.246a.519.519,0,0,1,.28.888c-.379.372-.761.742-1.142,1.112q-.782.761-1.565,1.521a.118.118,0,0,0-.04.12q.314,1.814.622,3.628a.816.816,0,0,1,0,.317.511.511,0,0,1-.742.324c-.432-.222-.861-.45-1.29-.675q-1.03-.54-2.058-1.082a.125.125,0,0,0-.133.005L3.062,12.164a.523.523,0,0,1-.733-.186.487.487,0,0,1-.061-.326q.192-1.121.384-2.242c.087-.5.175-1.008.258-1.513a.147.147,0,0,0-.046-.107q-.837-.82-1.678-1.635C.845,5.822.5,5.49.16,5.155a.491.491,0,0,1-.131-.532.5.5,0,0,1,.413-.351c.15-.027.3-.045.454-.067l2.525-.366c.255-.037.51-.076.765-.109A.136.136,0,0,0,4.3,3.643Q5.126,1.973,5.951.3A.52.52,0,0,1,6.439,0",
    transform: "translate(0)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.d477c842c344e134d23e6106e8ec3720.svg";
export { ForwardRef as ReactComponent };